// Google Consent Mode v2 — pont entre la bannière de consentement et gtag
// Le bootstrap (defaults) est fait dans /public/index.html avant le chargement d'AdSense.
// Cette fonction met à jour le consentement quand l'utilisateur fait un choix.

const get = () => (typeof window !== "undefined" && typeof window.gtag === "function" ? window.gtag : null);

/**
 * Met à jour Google Consent Mode v2 selon le choix utilisateur.
 * @param {{ stats: boolean, ads: boolean }} state
 */
export const updateGoogleConsent = ({ stats, ads }) => {
  const gtag = get();
  if (!gtag) return;

  const a = ads ? "granted" : "denied";
  const s = stats ? "granted" : "denied";

  gtag("consent", "update", {
    ad_storage: a,
    ad_user_data: a,
    ad_personalization: a,
    analytics_storage: s,
    personalization_storage: s,
  });

  // Active la redaction quand l'utilisateur refuse la pub : Google n'envoie alors
  // aucun identifiant ni cookie, mais conserve les conversions modélisées (légal RGPD).
  gtag("set", "ads_data_redaction", !ads);
};

export const ALL_GRANTED = { stats: true, ads: true };
export const ALL_DENIED = { stats: false, ads: false };
